import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy} from '@angular/core';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StaticPageService} from '../../../../../services/cms/static-page.service';
import {StaticPage} from '../../../../../models/cms/static-page';

@Component({
  selector: 'app-static-page-viewer',
  imports: [
    ReactiveFormsModule,
    FormsModule
],
  templateUrl: './static-page-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './static-page-viewer.component.scss'
})
export class StaticPageViewerComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() staticPage: StaticPage | null = null;

  @ViewChild('iframe') iframe: ElementRef | null = null;

  previewHtml: string | null = null;
  country: string = 'FR';
  loading = false;

  constructor(
    private staticPageService: StaticPageService,
  ) {
  }

  ngOnInit(): void {
    const language = navigator.language.split('-');
    if (language.length === 2) {
      this.country = language[1];
    } else {
      this.country = 'FR';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['staticPage']) {
      this.refresh();
    }
  }

  ngAfterViewInit() {
    const iframe = this.iframe?.nativeElement;

    iframe.addEventListener('load', () => {
      const iframeDocument = iframe.contentDocument;
      if (!iframeDocument) return;

      const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          const doc = iframe.contentDocument || iframe.contentWindow.document;
          const height = Math.max(
            doc.body.scrollHeight,
            doc.body.offsetHeight,
            doc.body.clientHeight,
            doc.documentElement.scrollHeight,
            doc.documentElement.offsetHeight,
            doc.documentElement.clientHeight
          );
          iframe.style.height = height + 'px';
        }
      });

      observer.observe(iframeDocument.body);
    });
  }

  refresh(): void {
    if (this.staticPage) {
      this.loading = true;

      this.staticPageService.preview(this.staticPage, this.country).subscribe(result => {
        this.previewHtml = result['html'];

        this.update();

        this.loading = false;
      });
    }
  }

  update(): void {
    const iframe = this.iframe?.nativeElement;
    if (iframe) {
      iframe.style.height = '0px';
      iframe.srcdoc = this.previewHtml ?? '';
    }
  }
}
